import { styled } from "goober";
import { Text } from "./Text";

export const StatusLineRow = styled("div")`
  display: flex;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const HttpStatusBadge = styled("span")`
  flex-shrink: 0;
  padding: 1px 5px;
  border-radius: 6px;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 500;
  line-height: 20px;
`;

function badgeColors(code: string): { background: string; color: string } {
  const n = Number.parseInt(code, 10);
  if (n >= 200 && n < 300)
    return { background: "var(--green-400)", color: "var(--green-1000)" };
  if (n >= 300 && n < 400)
    return { background: "var(--sky-400)", color: "var(--sky-1000)" };
  if (n >= 400 && n < 500)
    return { background: "var(--orange-400)", color: "var(--orange-1000)" };
  if (n >= 500)
    return { background: "var(--red-400)", color: "var(--red-1000)" };
  return { background: "var(--alpha4)", color: "var(--text-primary)" };
}

export function HttpStatusLine({
  statusCode,
  statusText,
  httpVersion,
}: {
  statusCode: string;
  statusText: string;
  httpVersion?: string;
}) {
  return (
    <StatusLineRow>
      <HttpStatusBadge style={badgeColors(statusCode)}>
        {statusCode}
      </HttpStatusBadge>
      <Text
        variant="code-regular"
        color="var(--text-primary)"
        style={{
          whiteSpace: "pre-wrap",
          overflowWrap: "anywhere",
          minWidth: 0,
        }}
      >
        {statusText}
      </Text>
      {httpVersion && (
        <Text
          variant="code-regular"
          color="var(--text-secondary)"
          style={{ marginLeft: "auto", whiteSpace: "nowrap" }}
        >
          {httpVersion}
        </Text>
      )}
    </StatusLineRow>
  );
}
